var map = {
	"./blueberries.gif": 30196,
	"./blueberries.png": 41126,
	"./garlic.gif": 69683,
	"./garlic.png": 83125,
	"./green_apples.gif": 77888,
	"./green_apples.png": 6713,
	"./green_radish.gif": 87375,
	"./green_radish.png": 58562,
	"./lemons.gif": 30335,
	"./lemons.png": 81140,
	"./oranges.gif": 458,
	"./oranges.png": 66962,
	"./peaches.gif": 75072,
	"./peaches.png": 5171,
	"./purple_radish.gif": 66816,
	"./purple_radish.png": 29405,
	"./tomatoes.gif": 41573,
	"./tomatoes.png": 94757,
	"./watermelon.gif": 83543,
	"./watermelon.png": 77845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83655;